import { render, staticRenderFns } from "./performanceDetail.vue?vue&type=template&id=e2af4112&scoped=true&"
import script from "./performanceDetail.vue?vue&type=script&lang=js&"
export * from "./performanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./performanceDetail.vue?vue&type=style&index=0&id=e2af4112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2af4112",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2af4112')) {
      api.createRecord('e2af4112', component.options)
    } else {
      api.reload('e2af4112', component.options)
    }
    module.hot.accept("./performanceDetail.vue?vue&type=template&id=e2af4112&scoped=true&", function () {
      api.rerender('e2af4112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/performanceDetail.vue"
export default component.exports